import * as PIXI from "pixi.js"
import TWEEN from "@tweenjs/tween.js"
import R from "../../config/R";
import Button from "../../objects/Button";
import * as Events from "../../Events";
import Image from "../../objects/Image";

export default class Heart extends PIXI.Container {
  constructor(x,y, resources){
    super()
    this.x = x
    this.y = y

    const heartTexture = resources[R.images.heart.name].texture
    const heartHollowedTexture = resources[R.images.heartEmpty.name].texture
    const heart = new Image(0, 0, heartTexture)
    const heartHollowed = new Image(0,0, heartHollowedTexture)

    this.addChild(heart)

    this.heart = heart
    this.heartHollowed = heartHollowed
  }

  setHollow(bool){
    this.removeChildren()
    if(bool){
      this.addChild(this.heartHollowed)
    }
    else {
      this.addChild(this.heart)
    }
  }
}


// WEBPACK FOOTER //
// ./src/game/characters/common/Heart.js